import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner} from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { ingresoLst } from 'src/app/models/ingresoLst';
import { ReporteService } from 'src/app/services/reporte.service';
import { ListaCodigoNoIngreso } from 'src/app/models/LISTAS';
@Component({
  selector: 'app-ingesos-hoy',
  templateUrl: './ingesos-hoy.component.html',
  styleUrls: ['./ingesos-hoy.component.scss'],
})
export class IngesosHoyComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  // pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public reporteSvc: ReporteService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: any[] = [];
    this.displayedColumns = [
      'nombre',
      'disciplina',
      'fecha',
      'resultado',
    ];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.getIngresosHoy(0, 10);
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getIngresosHoy(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.reporteSvc
      .getIngresosHoy(page, numReg, this.searchString)
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<ingresoLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
        console.log('resultado: ', result);
      });

    /*     let lstIngresos: any = [];

    for (let index = 0; index < 10; index++) {
      lstIngresos.push({
        id: index + 'a',
        nombre: 'usuario ' + index,
        empresa: 'torutgas',
        disciplina: 'natacion',
        fecha: '2021-11-26 11:45 am',
        resultado: index % 2 == 0,
      });
    }

    this.dataSource = new MatTableDataSource<ingresoLst>(lstIngresos);
    this.pageIndex = page;
    this.pageSize = numReg;
    this.length = 10; */
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getIngresosHoy(event.pageIndex, event.pageSize);
  }

  getTextoCodigoNoIngreso(codigo: number): string {
    return ListaCodigoNoIngreso.find((x) => x.codigo == codigo)?.texto || '';
  }
}
